import type { EFreqLimit } from '@web/entities/measurement/model/enums/specter.enum.ts'

export const visualFreqLimitMap: { [key in EFreqLimit]: number } = {
  RATE_78_125: 78.125,
  RATE_156_25: 156.25,
  RATE_312_5: 312.5,
  RATE_625: 625,
  RATE_1250: 1_250,
  RATE_2500: 2_500,
  RATE_5000: 5_000,
  RATE_10000: 10_000,
  RATE_20000: 20_000
} as const

export const visualFreqLimitOptions = Object.entries(visualFreqLimitMap)
  .map(([key, value]) => ({
    value: key,
    label: value.toString(),
    number: value
  }))
  .sort((a, b) => b.number - a.number)
